import styled from "styled-components";

import { colors } from "../../styles";

const WhiteBox = styled.div`
  background-color: ${colors.white};
  border: 0;
  box-shadow: 0 2px 22px -11px rgba(0, 0, 0, 0.5);
  border-radius: 10px;
  overflow: hidden;
  max-width: 100%;
  /* padding: 1rem; */
`;

export default WhiteBox;
